import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';

import { JobPosition } from '@restworld/utility-types';

import { jobActiveStatusAtom } from '../job-position/job-position.atoms';
import { JobExpireInformation } from '../legacy';
import { OfflineJobLandingModal } from '../offline-job-landing';

export const JobStatusInfo = ({ jobPositionApiData }: { jobPositionApiData: Partial<JobPosition> }) => {
  const jobActiveStatus = useAtomValue(jobActiveStatusAtom);
  const router = useRouter();

  // Dev-only preview: `?offline_variant=A|A_hybrid_thin|B` already picks which
  // scenario the modal renders, but the modal itself only mounts on a paused
  // JP. Outside production the same flag also forces it to mount on an active
  // one, so the layout can be reviewed without pausing a real listing on stage.
  const forcedByQuery = process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production' && !!router?.query?.['offline_variant'];

  if (jobActiveStatus && !forcedByQuery) return null;

  return <OfflineJobLandingModal jobPositionApiData={jobPositionApiData} />;
};
